import { useEffect, useState } from "react";
import { Link as RemixLink, Form, useActionData, useNavigation } from "@remix-run/react";
import { Input, Button, Checkbox } from "@heroui/react";
import { toast, ToastContainer } from "react-toastify";

interface ActionData {
  success: boolean;
  error?: string;
  errors?: any;
}

export default function LoginForm(): JSX.Element {
  const navigation = useNavigation();
  const actionData = useActionData<ActionData>();

  const [localErrors, setLocalErrors] = useState<Record<string, string>>({});
  const errors = localErrors;

  useEffect(() => {
    if (actionData?.errors) {
      setLocalErrors(actionData?.errors);
    }
  }, [actionData]);

  useEffect(() => {
    if (actionData?.error) {
      toast.error(actionData.error, {
        containerId: "loginToast",
      });
    }
  }, [actionData]);

  const handleInputChange = (fieldName: string) => {
    // Clear error when user starts typing

    setLocalErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
  };

  return (
    <div>
      <ToastContainer containerId="loginToast" />

      <Form method="post">
        <div className="py-4 flex flex-col justify-center items-center space-y-6">
          <div className="w-full ">
            <Input
              type="email"
              label="EMAIL ADDRESS"
              variant="underlined"
              size="lg"
              name="email"
              placeholder="Your Email"
              className="w-full"
              classNames={{
                input:
                  "peer text-black dark:!text-white autofill:!text-black dark:autofill:!text-white",
              }}
              errorMessage={errors?.email}
              isInvalid={!!errors?.email}
              onInput={() => handleInputChange("email")}
            />
          </div>

          <div className="w-full">
            <Input
              type="password"
              label="PASSWORD"
              variant="underlined"
              size="lg"
              name="password"
              placeholder="Your Password"
              className="w-ful"
              classNames={{
                input: "text-black dark:!text-white autofill:!text-black dark:autofill:!text-white",
              }}
              errorMessage={errors?.password}
              isInvalid={!!errors?.password}
              onInput={() => handleInputChange("password")}
            />
          </div>
          {/* <input type="hidden" name="isModal" value={isModal.toString()} /> */}

          <div className="py-6 w-full">
            <Button
              type="submit"
              variant="solid"
              color="primary"
              className="w-full"
              isLoading={navigation.state === "submitting"}
              disabled={navigation.state === "submitting"}
            >
              {navigation.state === "submitting" ? "Logging in..." : "LOGIN"}
            </Button>
          </div>

          <div className="w-full flex justify-between items-center">
            <Checkbox>Remember me</Checkbox>
            <a href="/forgot-password">Forgot your password?</a>
          </div>
        </div>
      </Form>
      <div className="flex gap-4 justify-center items-center text-center py-6 mt-4 border-y-1">
        <div>Don&apos;t have an account?</div>
        <Button
          as={RemixLink}
          prefetch="intent"
          to="/signup"
          variant="flat"
          className="text-amber-600 bg-white w-fit"
        >
          Create an Account
        </Button>
      </div>
    </div>
  );
}
